import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  dialog: {
    '& .MuiDialog-paper': {
      width: '100%'
    }
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    color: capitalDesignTokens.semanticColors.foreground.errorLarge
  },
  iconWrapper: {
    marginRight: '16px',
    color: capitalDesignTokens.semanticColors.foreground.errorLarge
  },
  dialogContent: {
    paddingLeft: '64px'
  },
  messageWrapper: {
    marginBottom: '16px'
  },
  confirmationInputWrapper: {
    paddingRight: '40px'
  },
  textField: {
    width: '100%',
    '&& .no-format:focus': {
      border: `0px solid ${capitalDesignTokens.semanticColors.interaction.focus}`,
      padding: '4px 10px'
    },
    '&& .no-format:hover': {
      border: 'none'
    },
    '& .MuiInputLabel-root': {
      pointerEvents: 'auto',
      cursor: 'text',
      userSelect: 'text'
    }
  },
  cancelButton: {
    minWidth: '60px',
    color: capitalDesignTokens.foundations.colors.gray800
  },
  loadingIcon: {
    marginLeft: '8px',
    color: capitalDesignTokens.foundations.colors.white
  }
});
